import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Layer, Source } from 'react-mapbox-gl'
import { makeGetLayerRendered } from '../selectors/layerRenderedSelector'

import { makeGetFeaturesSelected } from '../selectors/featureSelector'
import pipeline from '../config/pipeline.json'

import lineSplit from '@turf/line-split'
import lineSliceAlong from '@turf/line-slice-along'
import length from '@turf/length'
import lineOffset from '@turf/line-offset'

import nearestPointOnLine from '@turf/nearest-point-on-line'
import convex from '@turf/convex'
import booleanPointInPolygon from '@turf/boolean-point-in-polygon'
import { featureCollection, point } from '@turf/helpers'
import { coordAll } from '@turf/meta'
import DataActions from '../redux/dataRedux'

const authId = 'Infrastructure'

export class InfrastructurePipelineBuffer extends PureComponent {
  constructor () {
    super()

    this.state = {
      pointClicked: null,
      buffer: null
    }
  }

  static contextTypes = {
    map: PropTypes.object
  }

  componentDidMount () {
    const { map } = this.context
    map.on('click', this.handleClick)
  }

  componentWillUnmount () {
    const { map } = this.context
    map.off('click', this.handleClick)
  }

  handleClick = event => {
    const { map } = this.context
    const { actions } = this.props
    const { lng, lat } = event.lngLat
    const pointClicked = point([lng, lat])
    const buffer = this.generateBuffer(pointClicked)

    const features = map.querySourceFeatures('Infrastructure', {
      sourceLayer: 'infrastructure'
    })
    const selectedFeatures = features.filter(feature =>
      booleanPointInPolygon(feature, buffer)
    )

    const data = selectedFeatures.map(feature => feature.properties)

    actions.dataUpdated(data)
    this.setState({ pointClicked, buffer })
  }

  generateBuffer = pointClicked => {
    if (!pointClicked) {
      return null
    }

    const pipe = pipeline.features[0]
    const pipeLength = length(pipe, { units: 'miles' })
    const centerPoint = nearestPointOnLine(pipe, pointClicked)
    const splitLine = lineSplit(pipe, centerPoint).features[0]
    const splitLineLength = length(splitLine, { units: 'miles' })
    const startDistance = Math.max(splitLineLength - 0.5, 0)
    const stopDistance = Math.min(splitLineLength + 0.5, pipeLength)
    const line = lineSliceAlong(pipe, startDistance, stopDistance, {
      units: 'miles'
    })
    const offsetLeft = lineOffset(line, 300, { units: 'meters' })
    const offsetRight = lineOffset(line, -300, { units: 'meters' })
    const offsetLeftCoordinates = coordAll(offsetLeft)
    const offsetRightCoordinates = coordAll(offsetRight)
    const coordinates = [
      ...offsetLeftCoordinates,
      ...offsetRightCoordinates.reverse(),
      offsetLeftCoordinates[0]
    ]
    const points = featureCollection(
      coordinates.map(coordinate => point(coordinate))
    )
    const bufferConcave = convex(points, { concavity: 2 })

    return bufferConcave
  }

  render () {
    const { layerRendered } = this.props
    const { buffer } = this.state

    if (!layerRendered || !buffer) {
      return null
    }

    const bufferSource = {
      type: 'geojson',
      data: buffer
    }

    return (
      <div>
        <Source id={'pipelineBuffer'} geoJsonSource={bufferSource} />
        <Layer
          type='fill'
          id={'pipelineBuffer'}
          sourceId={'pipelineBuffer'}
          paint={{
            'fill-opacity': 0.2,
            'fill-color': 'white',
            'fill-outline-color': 'rgba(0, 0, 0, 1)'
          }}
        />
      </div>
    )
  }
}

const makeMapStateToProps = () => {
  const getLayerRendered = makeGetLayerRendered()

  const getFeaturesSelected = makeGetFeaturesSelected()
  const mapStateToProps = state => {
    return {
      idToken: state.login.idToken,
      layerRendered: getLayerRendered(
        state,
        'InfrastructurePipelineVector',
        authId
      ),
      time: state.layer.times.InfrastructurePipelineVector || undefined,
      featuresSelected: getFeaturesSelected(
        state,
        'InfrastructurePipelineVector'
      )
    }
  }
  return mapStateToProps
}

const mapDispatchToProps = dispatch => {
  return {
    actions: {
      dataUpdated: json =>
        dispatch(DataActions.dataFulfilled(json, 'InfrastructureBuffer'))
    }
  }
}

export default connect(makeMapStateToProps, mapDispatchToProps)(
  InfrastructurePipelineBuffer
)



// WEBPACK FOOTER //
// ./src/layers/InfrastructurePipelineBuffer.js